import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useOnboardingCheck } from 'features/onboarding/hooks/useOnboardingCheck';
import AppBar from 'components/AppBar';
import Sidebar from 'components/Sidebar';
import ContactSupportButton from 'components/ContactSupportButton';
import LoadingView from './LoadingView';

export default function AdminView(): JSX.Element {
  const { needsOnboarding, isLoading, currentStep } = useOnboardingCheck();

  // Show loading while checking onboarding status
  if (isLoading) {
    return <LoadingView />;
  }

  // Redirect to onboarding if needed, passing the current step as state
  if (needsOnboarding && currentStep !== null) {
    return <Navigate to="/onboarding" state={{ step: currentStep }} replace />;
  }

  // Normal admin view
  return (
    <>
      <div className="min-h-full">
        <div className="w-full fixed top-0 z-40">
          <AppBar />
        </div>

        <div className="flex h-full flex-col mt-[3.9rem]">
          <div className="flex min-h-0 flex-1">
            <Sidebar />

            <main className="min-w-0 flex-1 border-t border-gray-200 lg:flex ml-16">
              <Outlet />
            </main>
          </div>
        </div>

        <ContactSupportButton />
      </div>
    </>
  );
}
